import React from 'react';
import './index.scss';
import MetricsCardWrap from '../MetricsCardWrap';
import MetricsCardValue, { IMetricsCardValue } from '../MetricsCardValue';
import MetricsCardDod, { IMetricsDod } from '../MetricsCardDod';
import MetricsCardRank, { RankDataType } from '../MetricsCardRank';

interface IMetricsCardWrap {
  // 类名
  className?: string;
  // 样式
  style?: React.CSSProperties;
  // 中英文标题
  titleEn: string;
  titleCn: string;
  // 中英文副标题
  subtitleEn?: string;
  subtitleCn?: string;
  // 跳转链接
  link?: string;
  // 标题旁图标
  icon?: string;
  // 标题旁图片地址
  imgUrl?: string;
  // 是否开启icon的info提示（与标题hover的提示互斥）
  isIconTips?: boolean;
  // 中英文指标注释
  tipsEn?: string;
  tipsCn?: string;
  // 头部组件
  contentHeader?: React.ReactNode;
  // 尾部组件
  contentFooter?: React.ReactNode;
}

interface IMetricsCardDod {
  // 类名
  dodClassName?: string;
  // 样式
  dodStyle?: React.CSSProperties;

  dodData: IMetricsDod[];
}
interface IMetricsCardWithRank extends IMetricsCardWrap, IMetricsCardValue, IMetricsCardDod, IMetricsCardRank {
  valueStyle?: React.CSSProperties;
  metricsChart?: JSX.Element;
  valueClassName?: string;
}

interface IMetricsCardRank {
  // 类名
  rankClassName?: string;
  // 样式
  rankStyle?: React.CSSProperties;
  // 数据
  rankData: RankDataType[];
  // 值的格式
  rankFormatRule?: string;
  // 值的小数位
  subFormatRule?: string;
}

const MetricsCardWithRank = (props: IMetricsCardWithRank) => {

  const { titleEn, titleCn, subtitleEn, subtitleCn, icon, imgUrl, link, tipsEn, tipsCn, isIconTips, contentHeader, contentFooter, valueClassName, valueStyle, value, formatRule, emptyValue, preUnit, endUnit, dodClassName, dodStyle, dodData, rankClassName, rankStyle, rankData, rankFormatRule, subFormatRule, metricsChart, style, className } = props;

  return (
    <MetricsCardWrap
      titleCn={titleCn}
      titleEn={titleEn}
      className={className}
      style={style}
      link={link}
      tipsEn={tipsEn}
      tipsCn={tipsCn}
      icon={icon}
      imgUrl={imgUrl}
      isIconTips={isIconTips}
      subtitleEn={subtitleEn}
      subtitleCn={subtitleCn}
      contentHeader={contentHeader}
      contentFooter={contentFooter}
    >
      <div className={`dbd-metrics-card-with-rank__flex dbd-metrics-card-with-rank__row`}>
        <div className={'dbd-metrics-card-with-rank__left'}>
          <MetricsCardValue 
            className={valueClassName}
            style={valueStyle}
            value={value}
            formatRule={formatRule}
            emptyValue={emptyValue}
            preUnit={preUnit}
            endUnit={endUnit}
          />
          <MetricsCardDod 
            className={dodClassName}
            style={dodStyle}
            data={dodData}
          />
          {
            metricsChart && metricsChart
          }
        </div>
        <div className={`dbd-metrics-card-with-rank__right`}>
          <MetricsCardRank 
            className={rankClassName}
            style={rankStyle}
            data={rankData} 
            formatRule={rankFormatRule} 
            subFormatRule={subFormatRule}            
          />
        </div>
      </div>
    </MetricsCardWrap>
  );
};

export default MetricsCardWithRank;